import i18next, {TFunction} from "i18next";

i18next.init({
    ns: ['locale'],
    returnNull: false
});


export function getTranslationObject(): TFunction<string> {
    return i18next.t;
}
